export const IOS = 'ios';
export const ANDROID = 'android';
export const NA = 'na';



// WEBPACK FOOTER //
// ./app/constants/appDownloadType.js